<template>
  <div class="dropdown is-right is-hoverable">
    <div class="dropdown-trigger">
      <button class="is-rounded tag button"><font-awesome-icon icon="fa-solid fa-question" /></button>
    </div>
    <div class="dropdown-menu" role="menu">
      <div class="dropdown-content">
        <div class="dropdown-item has-text-left">
          <p><font-awesome-icon icon="fa-solid fa-user-gear" /> - Назначенный специалист</p>
          <p><font-awesome-icon icon="fa-solid fa-flag" /> - Статус</p>
          <p><font-awesome-icon icon="fa-solid fa-map-location" /> - Местоположение</p>
          <p><font-awesome-icon icon="fa-solid fa-clock-rotate-left" /> - Работоспособность восстановлена</p>
          <p><font-awesome-icon icon="fa-solid fa-arrow-right" /><font-awesome-icon icon="fa-solid fa-street-view" /> - Дата реакции</p>
          <p><font-awesome-icon icon="fa-solid fa-calendar-check" /> - Дата выполнения</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IconLegend"
}
</script>

<style scoped>

</style>